import { render, staticRenderFns } from "./GameLoadFailed.vue?vue&type=template&id=363c3aed"
import script from "./GameLoadFailed.vue?vue&type=script&lang=js"
export * from "./GameLoadFailed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports